import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGS } from '../i18n';

export const LanguageSwitcher = ({ inverted = false }) => {
  const { i18n, t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const current = i18n.language?.split('-')[0] || 'en';

  const switchTo = (lang) => {
    if (!SUPPORTED_LANGS.includes(lang)) return;
    window.localStorage.setItem('scrappy_lang', lang);
    i18n.changeLanguage(lang);
    const hash = location.hash || '';
    // Preserve current path segments after /:lang (e.g. /portfolio)
    const rest = location.pathname.replace(/^\/[^/]+/, '') || '';
    navigate(`/${lang}${rest}${hash}`);
  };

  const baseColor = inverted ? 'text-page/70' : 'text-muted';
  const activeColor = inverted ? 'text-page' : 'text-ink';
  const separator = inverted ? 'text-page/30' : 'text-ink/25';

  return (
    <div
      className="inline-flex items-center gap-1.5 text-xs font-mono tracking-widest2"
      role="group"
      aria-label={t('nav.languageLabel')}
      data-testid="language-switcher"
    >
      {SUPPORTED_LANGS.map((lang, i) => (
        <span key={lang} className="inline-flex items-center gap-1.5">
          <button
            type="button"
            onClick={() => switchTo(lang)}
            aria-current={current === lang ? 'true' : 'false'}
            className={`uppercase tracking-widest2 transition-colors duration-300 hover:text-clay ${
              current === lang ? `${activeColor} font-semibold` : baseColor
            }`}
            data-testid={`lang-switch-${lang}`}
          >
            {lang}
          </button>
          {i < SUPPORTED_LANGS.length - 1 && <span className={separator}>/</span>}
        </span>
      ))}
    </div>
  );
};
